class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    // Ore fix: by default Shopify's predictive search (the live
    // dropdown) and the full /search results page only match against
    // title/vendor/product_type — NOT variant SKUs — so searching a
    // part number (e.g. LOV.23115.AB) returned nothing. Adding
    // variants.sku (plus tag/body so material mentioned in the
    // description can match too) to the searched fields fixes both.
    // Injected here as a hidden form field — rather than editing the
    // large header.liquid template directly — because this component
    // already wraps the header search form on every page, and the
    // same hidden field is picked up by the full-page search submit.
    this.form = this.input ? this.input.form : null;
    if (this.form && !this.form.querySelector('input[name="options[fields]"]')) {
      var fieldsInput = document.createElement('input');
      fieldsInput.type = 'hidden';
      fieldsInput.name = 'options[fields]';
      fieldsInput.value = 'title,product_type,variants.title,variants.sku,vendor,tag,body';
      this.form.appendChild(fieldsInput);
    }

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    // Ore fix: same fields addition as above, for the live dropdown
    // (this request is separate from the form submit).
    const searchFields = 'title,product_type,variants.title,variants.sku,vendor,tag,body';
    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&resources[limit_scope]=each&resources[options][fields]=${encodeURIComponent(searchFields)}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);